import React from 'react';

interface IGenericErrorView {
  imgUrl: string;
  alt: string;
  header: string;
  description: string;
  ActionComponent?: () => JSX.Element;
}

const GenericErrorView: (p: IGenericErrorView) => JSX.Element = (p) => {
  const { imgUrl, alt, header, description, ActionComponent } = p;
  return (
    <div
      className="flex justify-center items-center flex-col m-8"
      data-testid="error-view"
    >
      <img src={imgUrl} alt={alt} />
      <h1 className="mt-8 text-2xl font-ubuntu">{header}</h1>
      <p className="mt-2 text-center">{description}</p>
      {ActionComponent && (
        <div className="mt-6">
          <ActionComponent />
        </div>
      )}
    </div>
  );
};

export default GenericErrorView;
